// extracted by mini-css-extract-plugin
module.exports = {"button":"PriceListBO_button__2FKr3","icon":"PriceListBO_icon__1hhQQ","collapseIcon":"PriceListBO_collapseIcon__3T4cS"};